module.exports = __webpack_public_path__ + "img/icon-search.ec38b583.svg";